<template>
  <div>
    <table>
      <tr>
        <td style="width:40px" valign="top" class="text-right">
          <img
            :style="{ width: width, height: height }"
            :src="comment.user_photo"
            alt
          />
        </td>
        <td valign="middle" v-if="!is_edit">
          <div class="d-flex justify-content-start align-items-center comment">
            <div class="comment-body mb-1" style="width: fit-content;">
              <p class="text-primary" v-tooltip="comment.user_type">
                <b>{{ comment.user_name }}</b>
              </p>
              <p>{{ comment.comments }}</p>
            </div>
            <a-popover trigger="click" placement="bottom" v-if="comment.author">
              <template slot="content">
                <a href="#" @click.prevent="onEdit">{{ $t('edit') }}</a> <br />
                <a href="#" @click.prevent="onDestroy">{{ $t('delete') }}</a>
              </template>
              <span class="ml-2 more-action">
                <strong>...</strong>
              </span>
            </a-popover>
          </div>
          <div class="ts-inline">
            <a href="#" class="ts-text-xs" @click.prevent="onReply">{{
              $t('reply')
            }}</a>
          </div>
          <div class="ts-inline ml-2 mr-2">{{ agoTime(comment.dates) }}</div>
        </td>
        <td valign="middle" v-if="is_edit">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('homework.writeCommentHere')"
            v-model.trim="model.comments"
            @keyup.enter.prevent="update"
          />
          <a href="#" @click="cancelEdit">{{ $t('cancel') }}</a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'displayComment',
  props: {
    record: {
      type: Object,
      default: {}
    },
    width: {
      type: String | Number,
      default: '35px'
    },
    height: {
      type: String | Number,
      default: '35px'
    }
  },
  data() {
    return {
      is_edit: false,
      sending: false,
      comment: {},
      model: {
        comments: '',
        student_homework_id: '',
        reference_id: null,
        comment_type_id: 1 // comment as text
      }
    }
  },
  created() {
    this.comment = this.record
  },
  methods: {
    onEdit() {
      this.is_edit = true
      this.model.comments = this.record.comments
      this.model.student_homework_id = this.record.student_homework_id
      this.model.reference_id = this.reference_id
    },
    update() {
      if (!this.model.comments) return

      this.sending = true
      this.$store
        .dispatch('eschool/homeworkCommentPrivate/update', {
          id: this.record.id,
          data: this.model
        })
        .then(response => {
          this.sending = false
          this.is_edit = false
          this.comment.comments = response.data.comments
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading_comment = false
        })
    },
    onDestroy() {
      this.$store.commit(
        'eschool/homeworkCommentPrivate/REMOVE_RECORD',
        this.record
      )
      this.$store
        .dispatch('eschool/homeworkCommentPrivate/destroy', this.record.id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onReply() {
      this.$store.commit(
        'eschool/homeworkCommentPrivate/SHOW_REPLY_INPUT_BOX',
        this.record
      )
      this.$emit('reply')
    },
    clearInput() {
      this.model.comments = ''
      this.model.student_homework_id = ''
      this.model.reference_id = ''
    },
    cancelEdit() {
      this.is_edit = false
      this.clearInput()
    },
    agoTime(date) {
      return moment(date).fromNow(true)
    }
  }
}
</script>

<style lang="css" scoped>
.comment-body {
  border-radius: 9px;
  /* border: 1px solid #f4f1f1; */
  padding: 5px;
  background-color: #f2f3f5;
  margin-bottom: -3px;
}
table {
  width: 100%;
}
img {
  display: inline;
  border-radius: 103px;
  padding: 3px;
  object-fit: cover;
  object-position: center;
  background: #fff7f7;
}
.comment:hover .more-action {
  visibility: visible;
}
.more-action {
  cursor: pointer;
  visibility: hidden;
}
</style>
